export class FolderStructureDTO{
    public id?:number;
    public businessId!:string;
    public clientId?:number;
    public structure!:string;
    public context?:string;
    public contextId?:number;
    public added?:string;
    public addedByUser?:string;
    public edited?:string;
    public lastEditedByUser?:string;
}